<template>
    <div class="modal-card">
        <header class="modal-card-head has-bg-danger">
            <p class="modal-card-title">{{$t('MODALLISTARPECAS.LISTARAMBIENTES')}}</p>
        </header>
        <section class="modal-card-body is-paddingless">
            <div class="panel">
                 
                
                <p  v-if="pecas !=null && pecas.length>0"   class="panel-block">
                    <b-field :label="$t('MODALLISTARPECAS.PECAS')">
                    </b-field>
                </p>           
                <div v-if="pecas !=null && pecas.length>0"  class="panel-block">
                    <b-input v-model="procurarPecas"
                             icon="magnify"
                             icon-right="close-circle"
                             icon-right-clickable
                             @icon-right-click="procurarPecas = ''"></b-input>
                </div>                     
                <div  v-if="pecas !=null && pecas.length>0"   class="panel-block"> 
                    <table  class="table  is-fullwidth is-striped">
                        <thead>
                            <tr>
                                <th></th>
                                <th>Cód. Produto</th>
                                <th>Produto</th> 
                                <th>Quantidade</th>
                                <th>Px/Compl</th>
                                                                                                     
                            </tr>                                                
                        </thead>
                        <tbody>                                                
                            <tr v-for="(peca, index) in filteredPecas" :key="index">
                                
                                <td>
                                        <b-checkbox :disabled="pecaSelecionada!=null && !peca.selecionado"  @input="changedPeca(peca)"
                                        size="is-small" type="is-info"  v-model="peca.selecionado"></b-checkbox >                                    
                                </td>                                
                                <td>{{peca.codigoProduto}}</td>                                                                                                       
                                <td>{{peca.descricao}}</td>                                                                                                       
                                <td>{{peca.quantidade}}</td>          
                                <td>{{peca.puxador}}</td>                                                                                                       

    
                            </tr>
                        </tbody>                        
                    </table>  
                </div>                
                            

            </div>
        </section>
        <footer class="modal-card-foot">
            <b-button type="is-success"
                     :loading="salvandoDados"
                      @click="confirmar">{{$t('SISTEMA.CONFIRMAR')}}</b-button>
            <b-button @click="$emit('close');  ">{{$t('SISTEMA.CANCELAR')}}</b-button>
        </footer>
    </div>
</template>

<script>
    import moment from 'moment';
    import { mapState } from 'vuex'
    
    export default {
        props: {
            guiaId: Number,   
            clienteCodigoExterno: Number,
            apenasEmAbertos: {
                type: Boolean,
                default: false
            },
            ambienteSelecionado: Object
        },
        data() {
            return {          
                procurarPecas: '',                                    
                salvandoDados :false,                
                pecas:[],
                pecaSelecionada:null,                    
                descricao:'',                                                 
            }
        },
        computed: {
            ...mapState([                                
                'unidadeId',                
            ]),  
            filteredPecas() {
                return this.procurarPecas
                    ? this.pecas
                        .filter(x =>
                            x.descricao
                                .toUpperCase()
                                .indexOf(this.procurarPecas.toUpperCase()) > -1)
                    : this.pecas
            },            
        },        

        watch: {
            
            ambienteSelecionado: {
                immediate: true,
                handler() {                 
                    if(this.ambienteSelecionado!=null){
                        this.loadPecas();
                    }else{
                        this.pecas = [];
                    }                                    
                },
            },
        },       
        methods: {
                         
                         
            changedPeca(peca){
                this.descricao= '';
                                
                this.pecas.filter(x=>x.selecionado).forEach((p) => {

                                        
                    this.descricao += this.ambienteSelecionado.descricao + " - "  +  p.codigoProduto + " - " + p.descricao;

                    if(p.puxador)
                        this.descricao += " - " + this.$t('MODALLISTARPECAS.PUXADOR') + ': ' + p.puxador;

                    this.descricao += " - " + this.$t('MODALLISTARPECAS.QUANTIDADE') + ': ' + p.quantidade + "\n";    
                    
                });                
                
            },                           
                  

            loadPecas() {    
                this.salvandoDados = true;   
                
                const params = [];                                                                                                      
                params.push(`clienteId=${this.clienteCodigoExterno}`);  
                params.push(`guiaId=${this.guiaId}`);  
                params.push(`unidadeId=${this.unidadeId}`);                 
                params.push(`opcao=${this.ambienteSelecionado.opcao}`); 

                this.$http.get(`/api/integracao/ListarPecasAmbiente?${params.join('&')}`)                        
                    .then(res => res.data)
                    .then(data => {     
                        this.pecas = data;                       
                        this.isLoading=false;
                    }).finally(() => {                                
                        this.salvandoDados = false;                                                                                  
                    });               
                    
            },             
        
            async confirmar() {

                if(this.descricao==''){
                        this.$buefy.dialog.alert({
                            title: this.$t('SISTEMA.ATENCAO'),
                            message: this.$t('MODALLISTARPECAS.MENSAGEMSELECIONEPECA'),
                            type: 'is-warning',
                            hasIcon: true
                        }); 
                        return false;                              
                }else{                    
                    this.$emit('preencherTitulo', this.descricao);
                    this.$emit('close');                                  
                }                
                                      
            },
            

        }
    }
</script>